'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                id: 'a',
                d: 'M0 45h60V0H0z'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('path', {
                d: 'M19.754 45.485V34.712l1.912-2.7 2.025-3.825 1.237-1.237h10.574l1.8 2.587 1.35 3.375 1.237 1.8v10.686l-20.135.087z',
                fill: '#F7F7F8'
            }),
            _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement('path', {
                    fill: '#00D8C8',
                    d: 'M19.688 37.429H22.5v-1.893h-2.813zM37.5 37.429h2.813v-1.893H37.5z'
                }),
                _react2.default.createElement('path', {
                    fill: '#FFCF3F',
                    d: 'M1.875 44.054H3.75V39.32H1.875z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M3.75 37.429H1.875V0h52.5v12.821H5.625V3.786H7.5v7.143h45V1.893H3.75z'
                }),
                _react2.default.createElement('path', {
                    fill: '#00D8C8',
                    d: 'M19.526 31.75h2.328v-1.893h-2.328zM38.147 31.75h2.328v-1.893h-2.328z'
                }),
                _react2.default.createElement('path', {
                    fill: '#FFCF3F',
                    d: 'M56.25 44.054h1.875V0H56.25z'
                }),
                _react2.default.createElement('path', {
                    d: 'M41.25 43.956h-1.875v-8.99c0-.86-.344-1.09-.457-1.167l-.966-.652-1.597-4.433a2.563 2.563 0 0 0-2.4-1.696h-7.91c-1.07 0-2.035.682-2.4 1.696l-1.597 4.433-.965.652c-.114.076-.458.307-.458 1.166v8.99H18.75v-8.99c0-1.549.703-2.347 1.294-2.742l.45-.305 1.39-3.85a4.444 4.444 0 0 1 4.16-2.943h7.911a4.444 4.444 0 0 1 4.162 2.943l1.388 3.85.453.306c.589.394 1.292 1.192 1.292 2.741v8.99z',
                    fill: '#3F5060'
                }),
                _react2.default.createElement('path', {
                    fill: '#A7F2EB',
                    d: 'M36.789 34.655l-1.286-.009-4.4-.579h-2.205l-4.523.588h-1.163v-1.893h1.101l4.524-.588 2.448.009 4.401.579h1.103z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M21.563 41.214h16.875v-1.893H21.561z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M22.5 44.054h1.875v-3.786H22.5zM35.625 44.054H37.5v-3.786h-1.875z'
                }),
                _react2.default.createElement(
                    'mask',
                    {
                        id: 'b',
                        fill: '#fff'
                    },
                    _react2.default.createElement('use', {
                        xlinkHref: '#a'
                    })
                ),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    mask: 'url(#b)',
                    d: 'M46.875 44.054H45v-26.5H15v26.5h-1.875V15.66h33.75z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    mask: 'url(#b)',
                    d: 'M6.563 39.321h7.5V37.43h-7.5z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    mask: 'url(#b)',
                    d: 'M7.5 44.054H5.625V15.66h8.438v1.893H7.5zM54.375 44.054H52.5v-26.5h-6.563V15.66h8.438z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    mask: 'url(#b)',
                    d: 'M45.938 39.321h7.5V37.43h-7.5zM0 45h60v-1.893H0zM45.938 23.232h7.5V21.34h-7.5zM6.563 23.232h7.5V21.34h-7.5z'
                })
            )
        )
    );
};

DefaultIcon.defaultProps = {
    width: '60',
    height: '45',
    viewBox: '0 0 60 45',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var ProfileIcon = function (_React$Component) {
    _inherits(ProfileIcon, _React$Component);

    function ProfileIcon() {
        _classCallCheck(this, ProfileIcon);

        return _possibleConstructorReturn(this, (ProfileIcon.__proto__ || Object.getPrototypeOf(ProfileIcon)).apply(this, arguments));
    }

    _createClass(ProfileIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { fill: this.props.hover || this.props.active ? _colors.Colors.calmWhite : _colors.Colors.claimBlack, width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return ProfileIcon;
}(_react2.default.Component);

exports.default = ProfileIcon;